import React from "react";
import { CloseIcon } from "@util/svgicon";
import { useAuth } from "@context";

const NoBotInfo = () => {

  const { setNoBotInfoPopUp } = useAuth();

  const closePopUp = () => {
    setNoBotInfoPopUp(false)
  }

  return (
    <div className="noBotInfo-model">
      <div className='how_to_start_title'>
        <p style={{ paddingLeft: '250px' }} className='purchase_licence_letter'>FrodoBots</p>
        <div onClick={closePopUp}>
          <CloseIcon />
        </div>
      </div>
      <div className="noBot_info">
        <p className="noBot_info_title_head">Thank you for visiting FrodoBots!</p>
        <p className="noBot_info_title">
          There are currently no FrodoBots available that match your experience level. We strive to make our robots available as often as possible, with our most consistent availability period for game pass holders being from 8 AM-12 PM Singapore Time.
        </p>
        <p className="noBot_info_title">
          To get in touch with the team and for enquiries, find us on Discord:&nbsp;
          <a href="https://discord.gg/7k3mPF759Z" target="_blank" rel="noopener noreferrer" style={{ color: 'blue', textDecoration: 'underline' }}>
            FrodoBots Discord
          </a>
        </p>
        <p className="noBot_info_title">
          For game pass holders hoping to organise a time outside of this period, please open a up a #support-ticket:&nbsp;
          <a href="https://discord.gg/frodobots" target="_blank" rel="noopener noreferrer" style={{ color: 'blue', textDecoration: 'underline' }}>
            Support on Discord
          </a>
        </p>
      </div>
    </div>

  );
};

export default NoBotInfo;
